// MBO Niveau 1 Studies
// These are entry-level vocational studies

export const MBO_NIVEAU_1_STUDIES = [
  'Assistent Horeca',
  'Assistent Zorg en Welzijn',
  'Assistent Retail',
  'Assistent Techniek',
  'Assistent Administratie'
];

export default MBO_NIVEAU_1_STUDIES;

















